<template>
	<ui-form :model="params.data" :transfer-model.sync="submitData" v-slot="{data}">
		<ui-hidden v-model="data.id" autosubmit/>
		<ui-text v-model="data.title" label="标题"/>
		<ui-image v-model="data.img" uploadPath="/admin/common/file/upload" label="图片"/>
		<ui-text v-model="data.url" label="路由"/>
		<ui-select v-model="data.type" label="类型">
			<ui-option value="1" text="错题本" tag-type="success"/>
			<ui-option value="2" text="语文助手" tag-type="info"/>
		</ui-select>
		<ui-template>
			<ui-button type="submit" @submit="submit"></ui-button>
			<ui-button type="reset" v-if="params.type=='add'"></ui-button>
		</ui-template>
	</ui-form>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			submitData:{}
		};
	},
	methods:{
		submit(){
			this.$axios.request({url:'/admin/ads/option',data:this.submitData,method:this.params.type})
			.then(data=>{
				this.close();
			}).end();
		},
	},
}
</script>

<style>
</style>
